import { isPending } from "@reduxjs/toolkit"

export const enumDauVaoTinNhan = {
    telegramweb: '0',
    android: '1',
    bot: '2',
    telegram: '3',
}
// trạng thái phân tích tin nhắn telegram
export const enumParseState = {
    isPending: 0,
    parseOk: 1,
    parseError: 2,
    skipped: 3
}